import React from 'react';
import {useLazyLoadQuery} from 'react-relay/hooks';
import {STEM_OFFSET} from '../../constants';
import Currency from '../../components/currency/currency';
import {graphqlWhoamiNextQuery} from '../../components/graphql';
import './stem-balance.scss';

const StemBalance = () => {
    const {whoamiNext} = useLazyLoadQuery(graphqlWhoamiNextQuery);
    const balance = whoamiNext?.balance ? whoamiNext.balance / STEM_OFFSET || 0 : 0;
    return (
        <div className='stem-balance-container text-md color-white display-flex align-items-center position-absolute top-1dot5rem right-1dot25rem mw768-top-1dot75rem'>
            <span className='stem-balance padding-right-0dot125rem'>{balance}</span>
            <Currency {...{isStem: true, theme: 'primary', stemIconClasses: 'display-block width-1dot25rem height-1dot25rem'}}/>
        </div>
    )
};

export default React.memo(StemBalance);